/* unplugin-vue-components disabled */import { render } from "./DeviceIdfv.vue?vue&type=template&id=3074e888&scoped=true"
import script from "./DeviceIdfv.vue?vue&type=script&lang=js"
export * from "./DeviceIdfv.vue?vue&type=script&lang=js"

import "./DeviceIdfv.vue?vue&type=style&index=0&id=3074e888&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/txgynew-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3074e888"]])

export default __exports__